
export interface NodeFsType {
  statSync(filePath: string): { size: number };
}

/**
 * Throws an exception if the file does not exist.
 */
export const getFileSize = (fsParam: NodeFsType, filePath: string): number => {
  const stats = fsParam.statSync(filePath);
  const fileSizeInBytes = stats['size'];
  return fileSizeInBytes;
};
